module.exports = __webpack_public_path__ + "img/arrow-right.397a0525.svg";